/**
 * Resolves the debounce time for a given bank/lift/message using 3-tier lookup:
 *   1. Lift-specific override  (bankId:liftId:deviceType:code)
 *   2. Bank-wide override      (bankId:*:deviceType:code)
 *   3. Adapter key default     (deviceType:code)
 *
 * Returns 0 when nothing is configured.
 */
export default function resolveDebounceTime(
  overrideMap: Map<string, number>,
  defaultMap: Map<string, number>,
  bankId: string,
  liftId: string,
  deviceType: string,
  code: number
): number {
  const suffix = `${deviceType}:${code}`;

  return (
    overrideMap.get(`${bankId}:${liftId}:${suffix}`) ??
    overrideMap.get(`${bankId}:*:${suffix}`) ??
    defaultMap.get(suffix) ??
    0
  );
}
